import { createFileRoute } from '@tanstack/react-router';
import { GuideAnalyticsDashboard } from '@/components/analytics/GuideAnalyticsDashboard';
import { Main } from '@/components/main';
import MainHeader from '@/components/layout/MainHeader';
import { useDocumentTitle } from 'usehooks-ts';
import { APP_NAME } from '@/lib/env';
export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/analytics'
)({
  component: AnalyticsPage,
});

function AnalyticsPage() {
  useDocumentTitle(`Analytics - ${APP_NAME}`);
  
  return (
    <Main fixed className="h-full">
      <MainHeader />
      <div className="h-full overflow-auto">
        <GuideAnalyticsDashboard />
      </div>
    </Main>
  );
}